import {TestType} from '@esgi/core/enums';

export const testTypes = [
	{id: TestType.YN, code: 'Y/N', name: 'Yes/No'},
	{id: TestType.Score, code: 'SS', name: 'Single Score'},
	{id: TestType.Rubric, code: 'R', name: 'Rubric'},
];
